var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { t } from 'helpers/i18n';
import { toDate, toDateTime } from 'helpers/Format';
import { rules } from 'helpers/Validation';
import { Form, Modal, Table } from 'components';
import { Button, FieldType } from 'elements';
import { loading } from 'elements/Loading';
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    function Index() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            create: false,
            stock: _this.props.stock
        };
        _this.fields = [
            {
                name: 'branch',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .integer()
                    .required(),
                options: _this.props.branches.map(function (branch) {
                    return { name: branch.name, value: String(branch.id) };
                })
            },
            {
                name: 'quantity',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .required()
            },
            {
                name: 'date',
                type: FieldType.DateTime,
                rules: rules()
                    .date()
                    .required()
            }
        ];
        _this.toggleCreate = function () { return _this.setState({ create: !_this.state.create }); };
        _this.handleSubmit = function (stocks) {
            return _this.props.store.stock
                .create(__assign(__assign({}, stocks), { article: _this.props.article }))
                .then(function (stock) {
                _this.toggleCreate();
                _this.setState({ stock: stock });
            });
        };
        _this.formatItems = function (items) {
            return items.map(function (item) { return (__assign(__assign({}, item), { date: _this.props.store.UI.isDesktop
                    ? toDateTime(item.date)
                    : toDate(item.date) })); });
        };
        return _this;
    }
    Index.prototype.render = function () {
        var _a = this.props, branches = _a.branches, store = _a.store;
        var _b = this.state, create = _b.create, _stock = _b.stock;
        var items = branches.map(function (branch) {
            var stock = (_stock || []).find(function (item) { return item.branch === branch.id; });
            return {
                branch: branch.name,
                quantity: stock ? stock.quantity : 0,
                date: stock ? stock.date : ''
            };
        });
        return (React.createElement("div", null,
            React.createElement(Title, null, t('stock')),
            React.createElement(Table, { items: this.formatItems(items), keyExtractor: function (item) { return item.branch; }, search: false }),
            React.createElement(AddButton, { primary: true, onClick: this.toggleCreate }, t('add')),
            create && (React.createElement(Modal, { title: t('stock'), onClose: this.toggleCreate },
                React.createElement(Form, { fields: this.fields, onCancel: this.toggleCreate, onSubmit: this.handleSubmit, delete: false })))));
    };
    Index = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.stock.read(props.article).then(function (stock) { return ({ stock: stock }); }),
            props.store.branches.read().then(function (branches) { return ({ branches: branches }); })
        ]; }),
        observer
    ], Index);
    return Index;
}(Component));
export default Index;
var Title = cxs('p')({
    fontSize: Theme.fontSize.big,
    textAlign: 'center'
});
var AddButton = cxs(Button)((_a = {
        width: '100%',
        borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
        marginBottom: Theme.size.bar,
        borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
    },
    _a[mediaQueries.desktop] = {
        marginBottom: 0
    },
    _a));



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stock/index.tsx
// module id = 1558
// module chunks = 0